export enum Role {
    OWNER = 'Propietario',
    ADMIN = 'Administrador',
    BASIC = 'Usuario',
    VISITOR = 'Visitante',
}
